export const ADDITIONAL_R2R = {
  ID: 'additionalR2R',
  TITLE: 'Dispositivos',
  PAYMENTS: {
    ID: 'additional-payments',
    NAME: 'additional-payments',
    LABEL: 'Elige la cuota mensual de tu',
    RULES: {
      REQUIRED: 'Campo obligatorio',
    },
  },
};
